import { Injectable } from '@angular/core';
import { Asset, Indication, ReferenceData  } from './models';

@Injectable({
  providedIn: 'root'
})

export class SearchService {

  selectedChannelIds: number[] = [];
  selectedTAIds: number[] = [];
  selectedAssetIds: number[] = [];
  selectedIndicationIds: number[] = [];

  actualChannelId: number;
  actualTAId: number;
  actualAssetId: number;
  actualIndicationId: number;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(){}

  isChannelChecked(id: number): boolean{
    return this.selectedChannelIds.findIndex(x => x == id) != -1;
  }

  isTaChecked(id: number): boolean{
    return this.selectedTAIds.findIndex(x => x == id) != -1;
  }

  isAssetChecked(id: number): boolean{
    return this.selectedAssetIds.findIndex(x => x == id) != -1;
  }

  isIndicationChecked(id: number): boolean{
    return this.selectedIndicationIds.findIndex(x => x == id) != -1;
  }

  hasFilterApplied(): boolean{
    return (this.selectedChannelIds && this.selectedChannelIds.length > 0)
     || (this.selectedTAIds && this.selectedTAIds.length > 0)
     || (this.selectedAssetIds && this.selectedAssetIds.length > 0)
     || (this.selectedIndicationIds  && this.selectedIndicationIds.length > 0);
  }

  applyFilters(): void{
    (this.actualChannelId) ? this.selectedChannelIds = [this.actualChannelId] : [];
    (this.actualTAId) ? this.selectedTAIds = [this.actualTAId] : [];
    (this.actualAssetId) ? this.selectedAssetIds = [this.actualAssetId] : [];
    (this.actualIndicationId) ? this.selectedIndicationIds = [this.actualIndicationId] : [];
  }

  getFilteredAssets(referenceData: ReferenceData): Asset[]{
    return referenceData.Assets.filter(x => this.selectedTAIds.findIndex(y => y == x.TAId) != -1);
  }

  getFilteredIndications(referenceData: ReferenceData): Indication[]{
    return referenceData.Indications.filter(x => this.selectedTAIds.findIndex(y => y == x.TAId) != -1);
  }

  selectedByChannels(id: number): void{
    const index = this.selectedChannelIds.findIndex(x => x == id);
    if(index != -1){
      this.selectedChannelIds = this.selectedChannelIds.filter(x => x != id);
    }
    else{
      this.selectedChannelIds.push(id);
    }
  }

  selectedByTas(id: number): void{
    const index = this.selectedTAIds.findIndex(x => x == id);
    if(index != -1){
      this.selectedTAIds = this.selectedTAIds.filter(x => x != id);
    }
    else{
      this.selectedTAIds.push(id);
    }
  }

  selectedByAssets(id: number): void{
    const index = this.selectedAssetIds.findIndex(x => x == id);
    if(index != -1){
      this.selectedAssetIds = this.selectedAssetIds.filter(x => x != id);
    }
    else{
      this.selectedAssetIds.push(id);
    }
  }

  selectedByIndications(id: number): void{
    const index = this.selectedIndicationIds.findIndex(x => x == id);
    if(index != -1){
      this.selectedIndicationIds = this.selectedIndicationIds.filter(x => x != id);
    }
    else{
      this.selectedIndicationIds.push(id);
    }
  }

  clearAll(): void {
    this.selectedChannelIds = [];
    this.selectedTAIds = [];
    this.selectedAssetIds = [];
    this.selectedIndicationIds = [];

    this.actualChannelId = null;
    this.actualTAId = null;
    this.actualAssetId = null;
    this.actualIndicationId = null;
  }

  resetChannel():void {
    this.selectedChannelIds = [];
    this.actualChannelId = null;
  }

  resetTa():void {
    this.selectedTAIds = [];
    this.actualTAId = null;
  }

  resetAsset():void {
    this.selectedAssetIds = [];
    this.actualAssetId = null;
  }

  resetIndication():void {
    this.selectedIndicationIds = [];
    this.actualIndicationId = null;
  }

  get showClearChannels(): boolean { return this.actualChannelId != null; }
  get showClearTAs(): boolean { return this.actualTAId != null; }
  get showClearAssets(): boolean { return this.actualAssetId != null; }
  get showClearIndications(): boolean { return this.actualIndicationId != null; }
}



